// extracted by mini-css-extract-plugin
module.exports = {"root":"_4c5d0b91198b1b2a17c0b44df5aabc8c-less","resetAfter":"aef43a3acf65621cb7067d25e274f2b1-less"};